import { Loading } from "@app/components";
import {
  useAnalysisTypes,
  useDetector,
  useIsotopos,
  useUser,
} from "@services/servicesGenericsTables";
import { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import { useCalibrationTritium } from "../../utils/useCalibration";

export default function CalibrationEditLayout() {
  const fetched = useRef(false);
  const [loading, setLoading] = useState(true);

  const { fetchAll: fetchAlluser } = useUser();
  const { fetchAll: fetchAllAnalysis } = useAnalysisTypes();
  const { clearCalibrationTritium } = useCalibrationTritium();
  const { fetchAll: fetchAllIsotopos } = useIsotopos();
  const { fetchAll: fetchAllDetector } = useDetector();
  useEffect(() => {
    if (!fetched.current) {
      fetched.current = true;
      const fetchData = async () => {
        await Promise.all([
          fetchAlluser(),
          fetchAllAnalysis(),
          clearCalibrationTritium(),
          fetchAllIsotopos(),
          fetchAllDetector(),
        ]);
        setLoading(false);
      };
      fetchData();
    }
  }, []);

  return loading ? <Loading /> : <Outlet />;
}
